"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_hooks_1 = require("@apollo/react-hooks");
var components_1 = require("@xyo-network/coin-forms/build/lib/components");
var react_1 = require("react");
var graphql_generated_1 = require("../../graphql.generated");
var invoke_1 = __importDefault(require("lodash/invoke"));
exports.useCreateGeoDropsMutation = function () {
    return react_hooks_1.useMutation(graphql_generated_1.CreateGeoDropsDocument);
};
exports.useDropFormContext = function () {
    return components_1.useFormValidationContext();
};
function useDropFormControls(callbacks) {
    var _this = this;
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = exports.useDropFormContext(), _c = _b[0], values = _c.values, initial = _c.initial, actions = _b[1];
    var setSuccess = components_1.useSetAlertSuccess();
    var setError = components_1.useSetAlertError();
    var _d = react_1.useState(null), details = _d[0], setDetails = _d[1];
    var createDrop = exports.useCreateGeoDropsMutation()[0];
    var handleSubmit = function (ev) { return __awaiter(_this, void 0, void 0, function () {
        var quantity, restrictToEmail, restrictToQuadkey, maxAvailable, maxAmount, maxQuantity, quadkey, email, input, targeting, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    ev.preventDefault();
                    setLoading(true);
                    return [4 /*yield*/, actions.validateFields()];
                case 1:
                    _a.sent();
                    quantity = values.quantity, restrictToEmail = values.restrictToEmail, restrictToQuadkey = values.restrictToQuadkey, maxAvailable = values.maxAvailable, maxAmount = values.maxAmount, maxQuantity = values.maxQuantity, quadkey = values.quadkey, email = values.email, input = __rest(values, ["quantity", "restrictToEmail", "restrictToQuadkey", "maxAvailable", "maxAmount", "maxQuantity", "quadkey", "email"]);
                    if (maxAvailable < input.amount * quantity) {
                        return [2 /*return*/, setError("Insufficient balance, please reduce amount or quantity. " + maxAvailable + " available.")];
                    }
                    targeting = {};
                    if (restrictToEmail && email)
                        targeting.email = email;
                    if (restrictToQuadkey && quadkey)
                        targeting.quadkey = email;
                    setDetails(__assign(__assign({ quantity: quantity }, targeting), input));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 3];
                case 3:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        setDetails(null);
    };
    var handleReset = function () {
        actions.setAllValues(initial);
    };
    var uploadImage = function (base64) { return __awaiter(_this, void 0, void 0, function () {
        var imageUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!callbacks.uploadImage) return [3 /*break*/, 2];
                    return [4 /*yield*/, callbacks.uploadImage(base64)];
                case 1:
                    imageUrl = _a.sent();
                    return [2 /*return*/, imageUrl];
                case 2: return [2 /*return*/, ''];
            }
        });
    }); };
    var handleConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var from, quantity, base64Image, input, imageUrl, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!details)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    setLoading(true);
                    from = details.from, quantity = details.quantity, base64Image = details.base64Image, input = __rest(details, ["from", "quantity", "base64Image"]);
                    return [4 /*yield*/, uploadImage(base64Image)];
                case 2:
                    imageUrl = _a.sent();
                    return [4 /*yield*/, createDrop({
                            variables: {
                                from: from,
                                quantity: quantity,
                                input: __assign(__assign({}, input), { imageUrl: imageUrl }),
                            },
                        })];
                case 3:
                    result = _a.sent();
                    setSuccess("Successfully created " + quantity + " geodrop" + (quantity === 1 ? 's' : '') + ".");
                    setDetails(null);
                    invoke_1.default(callbacks, 'onSuccess', result.data);
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _a.sent();
                    console.log(e_2);
                    setError(e_2);
                    invoke_1.default(callbacks, 'onError', e_2);
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        state: { values: values, loading: loading, details: details },
        actions: {
            handleSubmit: handleSubmit,
            handleCancel: handleCancel,
            handleConfirm: handleConfirm,
            handleReset: handleReset,
        },
    };
}
exports.useDropFormControls = useDropFormControls;
//# sourceMappingURL=controls.js.map